<!-- eslint-disable vue/no-template-shadow -->
<i18n>
{
  "cl": {
    "bankValidationError": "Debes elegir un banco",
    "passwordValidationError": "Debes ingresar tu clave",
    "idNumberError": "Debes ingresar un rut correcto",
    "cardCodeValidationError": "Coordenadas inválidas",
    "smsValidationError": "Clave inválida"
  }
}
</i18n>
<template>
  <div class="floid-content card-item">
    <div class="columns is-desktop">
      <div class="column">
        <div id="payment-details" class="card-item-details content">
          <h3>Resumen</h3>
          <div class="resume-text">
            <div
              v-for="(operation, operationId, i) in paymentsMap"
              :key="`operation${i}`">
              <h5 v-if="operation.length" class="credit-info">
                Crédito hipotecario N°{{ i + 1 }}
              </h5>
              <ul>
                <li
                  v-for="(payment, j) in paymentsMap[operationId]"
                  :key="`payment${i}${j}`"
                  class="fee-info">
                  Cuota
                  {{ payment.paymentNumber +'/'+
                    debt.filter(operation => operation.operationId == operationId)[0].termAsMonths }}:
                  $ {{ new Intl.NumberFormat('de-DE').format(payment.secondaryCurrencyTotalMonthlyPayment ) }}
                  <i class="fas" :class="[payment.lateDays > 0 ? 'fa-exclamation-triangle' : 'fa-check-circle']" />
                </li>
              </ul>
            </div>
            <!--h5>Total: UF {{ new Intl.NumberFormat('de-DE').format(123) }}</h5-->
            <h5>
              Valor UF: $ {{ new Intl.NumberFormat('de-DE').format(
                Object.values(paymentsMap)[0][0].secondaryCurrencyFactor
              ) }}
            </h5>
            <h4 class="is-pulled-right has-text-right">
              Total
              <p class="big-total-yellow">
                $
                <span class="big-total-number">
                  {{ new Intl.NumberFormat('de-DE').format(total) }}
                </span>
              </p>
            </h4>
          </div>
        </div>
      </div>
      <div class="column">
        <div id="payment-box" class="card-item">
          <h3>Transferencia</h3>
          <div class="pay-content">
            <div v-if="floidStep === 'spinner'" id="floid-spinner">
              <div class="clearfix">
                <p>{{ floidStatusMessage }}</p>
              </div>
              <div class="spinner-container">
                <div class="spinner">
                  <div class="double-bounce1" />
                  <div class="double-bounce2" />
                </div>
              </div>
            </div>
            <div v-show="floidErrorMessage" id="floid-errors" class="content notification is-danger">
              <button class="delete" @click="floidErrorMessage = ''" />
              {{ floidErrorMessage }}
            </div>
            <ValidationObserver v-if="floidStep === 'triggerPayment'" v-slot="{ valid, errors }">
              <!-- -->
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="bankName">Banco</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <ValidationProvider
                        v-slot="{ errors, valid }"
                        name="bankValidation"
                        rules="required|bankValidation">
                        <select
                          id="bankName"
                          v-model="bankName"
                          name="bankName"
                          class="creditu-select"
                          :class="{ '': errors[0], '': valid }">
                          <option value="">Elige tu banco favorito</option>
                          <option
                            v-for="(bank,i) in banksArray"
                            :key="`bank-${i}`"
                            :value="bank.value">
                            {{ bank.text }}
                          </option>
                        </select>
                      </ValidationProvider>
                    </div>
                    <p
                      v-if="errors && errors.bankValidation && errors.bankValidation.length"
                      class="help is-danger">
                      {{ $t('bankValidationError') }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- -->
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="rut">Rut</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <ValidationProvider v-slot="{ errors, valid }" name="idNumberCl" rules="required|idNumberCl">
                        <input
                          id="rut"
                          v-model="rut"
                          class="input"
                          placeholder="RUT"
                          type="text"
                          name="rut"
                          :class="{ '': errors[0], '': valid }">
                      </ValidationProvider>
                    </div>
                    <p
                      v-if="errors && errors.idNumberCl && errors.idNumberCl.length"
                      class="help is-danger">
                      {{ $t('idNumberError') }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- -->
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="password">Clave</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <ValidationProvider
                        v-slot="{ errors, valid }"
                        name="passwordValidation"
                        rules="required|passwordValidation">
                        <input
                          id="password"
                          v-model="bankPassword"
                          class="input"
                          placeholder=""
                          type="password"
                          name="password"
                          :class="{ '': errors[0], '': valid }">
                      </ValidationProvider>
                    </div>
                    <p
                      v-if="errors && errors.passwordValidation && errors.passwordValidation.length"
                      class="help is-danger">
                      {{ $t('passwordValidationError') }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- -->
              <div id="floidTriggerButtonn" class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="" />
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <button
                        class="button is-button-primary"
                        :disabled="!valid"
                        @click="() => {}">
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- -->
            </ValidationObserver>
            <ValidationObserver v-if="floidStep === 'smsCode'" v-slot="{ valid, errors }">
              <h4>Ingresa la clave requerida por tu banco</h4>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="bankName">Clave</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <ValidationProvider
                        v-slot="{ errors, valid }"
                        name="smsValidation"
                        rules="required|smsValidation">
                        <input
                          id="smsCode"
                          v-model="smsCode"
                          class="input"
                          placeholder=""
                          type="text"
                          name="smsCode"
                          :class="{ '': errors[0], '': valid }">
                      </ValidationProvider>
                    </div>
                    <p
                      v-if="errors && errors.smsValidation && errors.smsValidation.length"
                      class="help is-danger">
                      {{ $t('smsValidationError') }}
                    </p>
                  </div>
                </div>
              </div>
              <div id="floidTriggerButtonn" class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="" />
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <button
                        class="button is-button-primary"
                        :disabled="!valid"
                        @click="confirmPayment">
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ValidationObserver>
            <ValidationObserver v-if="floidStep === 'cardCode'" v-slot="{ valid, errors }">
              <h4>Ingresa las coordenadas</h4>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="bankName">Coordenadas</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <div class="columns has-text-centered">
                        <div v-for="(label,i) in cardCodeLabel" :key="`${label}-${i}`" class="column">{{ label }}</div>
                      </div>
                      <div class="columns has-text-centered">
                        <div class="column">
                          <div class="field is-expanded">
                            <div class="field has-addons">
                              <div class="control">
                                <ValidationProvider
                                  v-slot="{ errors, valid }"
                                  name="coord0"
                                  rules="required|cardCodeValidation:@coord0,@coord1,@coord2">
                                  <input
                                    id="coord0"
                                    v-model="cardCode[0]"
                                    class="has-text-centered input"
                                    maxlength="2"
                                    placeholder=""
                                    type="text"
                                    name="coord0"
                                    :class="{ '': errors[0], '': valid }">
                                </ValidationProvider>
                              </div>
                              <div class="control">
                                <ValidationProvider
                                  v-slot="{ errors, valid }"
                                  name="coord1"
                                  rules="required|cardCodeValidation:@coord0,@coord1,@coord2">
                                  <input
                                    id="coord1"
                                    v-model="cardCode[1]"
                                    class="has-text-centered input"
                                    maxlength="2"
                                    placeholder=""
                                    type="text"
                                    name="coord1"
                                    :class="{ '': errors[0], '': valid }">
                                </ValidationProvider>
                              </div>
                              <div class="control">
                                <ValidationProvider
                                  v-slot="{ errors, valid }"
                                  name="coord2"
                                  rules="required|cardCodeValidation:@coord0,@coord1,@coord2">
                                  <input
                                    id="coord2"
                                    v-model="cardCode[2]"
                                    class="has-text-centered input"
                                    maxlength="2"
                                    placeholder=""
                                    type="text"
                                    name="coord2"
                                    :class="{ '': errors[0], '': valid }">
                                </ValidationProvider>
                              </div>
                            </div>
                            <p
                              v-if="
                                errors &&
                                  (errors['coord0'] ||
                                    errors['coord1'] ||
                                    errors['coord2']) &&
                                  (errors['coord0'].length ||
                                    errors['coord1'].length ||
                                    errors['coord2'].length)
                              "
                              class="help is-danger has-text-left">
                              {{ $t('cardCodeValidationError') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="floidTriggerButtonn" class="field is-horizontal">
                <div class="field-label is-normal">
                  <label for="" />
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <button
                        class="button is-button-primary"
                        :disabled="!valid"
                        @click="confirmPayment">
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ValidationObserver>
            <p id="secure" class="has-text-centered is-size-7">
              <i class="icon fa fa-lock" />Tus datos están protegidos
              - <i class="icon fa fa-shield-alt" /> Vía <a href="https://floid.cl" target="_blank">floid</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmPaymentWithFoid } from '@/application/services/api-clients/payments';

export default {
  name: 'PayFloid',
  data() {
    return {
      bankName: '',
      bankPassword: '',
      rut: '',
      pageId: '',
      isApprovalOptional: false,
      floidStatusMessage: 'Estamos procesando tu transacción, es posible que debas autorizarla con la aplicación de tu banco',
      floidStep: 'triggerPayment', // triggerPayment, smsCode, cardCode, spinner
      cardCodeLabel: ['A2', 'B5', 'H5'],
      cardCode: ['', '', ''],
      transactionId: '',
      smsCode: '',
      floidErrorMessage: '',
      paymentsMap: this.$store.state.paymentsModule.paymentsMap,
      debt: this.$store.state.paymentsModule.debt,
      total: this.$store.state.paymentsModule.total,
      banksArray: [
        {
          text: 'Banco de Chile',
          value: 'banco chile'
        },
        {
          text: 'Banco Santander',
          value: 'banco santander'
        },
        {
          text: 'Banco del Estado',
          value: 'banco estado'
        },
        {
          text: 'Banco BCI',
          value: 'bci'
        },
        {
          text: 'Banco Bice',
          value: 'banco bice'
        },
        {
          text: 'Banco Itaú / Corpbanca',
          value: 'itau corpbanca'
        },
        {
          text: 'Banco Security',
          value: 'banco security'
        },
        {
          text: 'Banco Scotiabank',
          value: 'scotiabank'
        }
      ]
    };
  },
  watch: {
    floidStep: {
      immediate: true,
      handler(val) {
        this.$emit('enableBackButton', val === 'triggerPayment');
      }
    }
  },
  mounted() {
    this.$emit('sendNameBackStep', 'payment-provider');
  },
  methods: {
    socketHandler(data) {
      if (data.isValid) {
        if (data.approvalData) {
          this.floidStatusMessage = 'Procesando la transacción';
          this.pageId = data.pageId;
          if (data.approvalData.smsCode) {
            this.floidStep = 'smsCode';
            return;
          }
          // si no es smsCode, es cardCode
          this.floidStep = 'cardCode';
          this.cardCodeLabel = data.approvalData.cardCode;
          return;
        }
        this.$router.push({ name: 'choice' });
        this.sockets.listener.unsubscribe(this.transactionId);
        return;
      }
      this.sockets.listener.unsubscribe(this.transactionId);
      this.floidStep = 'triggerPayment';
      if (data.error === 'Invalid credentials') {
        this.floidErrorMessage = 'Credenciales inválidas';
      } else if (data.error === 'Approval failed') {
        this.floidErrorMessage = 'Transacción rechazada';
      } else if (data.error.name === 'TimeoutError') {
        this.floidErrorMessage = 'Se agotó el tiempo de espera para aprobar la transación';
      } else if (data.error === 'Enable approval with mobile app to make transfers') {
        this.floidErrorMessage = 'Habilita la aplicación móvil para validar la transferencia';
      } else {
        // error genérico
        this.floidErrorMessage = 'Algo salió mal';
      }
    },
    async confirmPayment() {
      this.floidStep = 'spinner';
      const transferData = this.floidStep === 'cardCode' ? { cardCode: this.cardCode } : { smsCode: this.smsCode };
      const { transactionId, bankName, pageId, isApprovalOptional } = this;
      try {
        await confirmPaymentWithFoid(transactionId, bankName, pageId, transferData, isApprovalOptional);
        this.isApprovalOptional = true;
      } catch (_error) {
        this.floidErrorMessage = 'Ocurrió un error al comunicarnos con el servidor';
        this.floidStep = 'triggerPayment';
      }
    },
    formatRut(rutIn) {
      let rut = rutIn.replace(/[^0-9kK]+/g, '').toUpperCase();
      const dv = rut.substring(rut.length - 1);
      rut = rut.substring(0, rut.length - 1);
      rut = new Intl.NumberFormat('de-DE').format(rut);
      return `${rut}-${dv}`;
    }
  }
};
</script>
<style scoped>
    #payment-details {
      background-color: #00CCD1;
      position: relative;
      box-shadow: var(--complete-shadow);
      border-radius: 40px;
      padding: 20px;
      width: 100%;
      overflow: hidden;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      color: white;
      transition: background 0.5s, box-shadow 0.5s;
    }
    #payment-details:hover {
      background: #00808F;
      box-shadow: 0 0 5px #00000030;
    }
    .big-total-yellow {
      color: #FFE66F;
    }
    .big-total-number {
      line-height: 0.8;
      font-size: 45px;
    }
    #payment-details h3 {
      text-align: center;
    }
    #payment-details h3, #payment-details h4, #payment-details h5 {
      color: white;
    }
    .floid-content {
      padding-top: 50px;
    }
    #payment-box {

    }
    #payment-box h3 {
      margin-bottom: 15px;
      text-align:center;
    }
    .field-label, .field-label label {
      text-align: left;
    }
    .floid-content {
        width: 95%;
        margin: 30px auto 50px;
        padding-bottom: 50px;;
    }
    .select {
        width: 100%;
        background-position: 95% 13px;
    }
    #floid-spinner {
    }
    .spinner-container {
      display: block;
      height: 95px;
    }
    .spinner {
      position: relative;
      top: 20px;
      display: block;
    }
    #floidTriggerButtonn {
      margin: 30px 0;
    }
    #floid-errors h5 {
      color: white;
      margin-top: 0;
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
</style>
